// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__cJIC3","overflowing":"ReadFullNote_overflowing__2rjpZ"};